import React, { useMemo, useState } from "react";
import { Dialog, DialogTitle, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { Switch, TextField as MaterialTextInput } from "@mui/material";

import { SimpleForm, TextInput, useNotify, useRefresh, useDataProvider, useRedirect } from "react-admin";

import languageTypes from "../../types/languageTypes";
import { Accordion, CustomToolbar } from "./utils";

const ClonePageVersionsDialog = ({ open, record, resource, pageName, route, close }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const redirect = useRedirect();

  const [versionName, setVersionName] = useState("");

  const [currentPageName, setCurrentPageName] = useState("");

  const [currentRoute, setCurrentRoute] = useState("");

  const [isNewPage, setIsNewPage] = useState(false);

  const [isNewLanguage, setIsNewLanguage] = useState(false);

  const [languageId, setLanguageId] = useState(1);

  const handleChange = event => {
    setLanguageId(event.target.value);
  };

  const handleNewLanguage = e => {
    const newLanguage = e.target.checked;
    setIsNewLanguage(newLanguage);
    newLanguage && setLanguageId(2);
  };

  const pageNameValue = useMemo(
    () => (isNewLanguage ? (!!currentPageName ? `${currentPageName}` : `${pageName} EN`) : currentPageName),
    [isNewLanguage, currentPageName, pageName],
  );

  const routeValue = useMemo(
    () => (isNewLanguage ? (!!currentRoute ? `${currentRoute}` : `en${route}`) : currentRoute),
    [isNewLanguage, currentRoute, route],
  );

  const onSubmit = e => {
    const baseUrl = `${resource}/${record.id}`;

    const url = isNewPage ? `${baseUrl}/page/clone` : `${baseUrl}/clone`;

    const data = isNewPage
      ? { name: pageNameValue, route: routeValue, languageId: languageId, pageVersionName: versionName }
      : { name: versionName };

    const cloneType = !isNewPage ? "Версията" : "Страницата";

    return dataProvider
      .create(url, {
        data: data,
        meta: { useFormData: false },
      })
      .then(response => {
        close();
        if (!isNewPage) {
          refresh();
        } else {
          redirect(`/pages-cms/${response?.data?.id}`);
        }

        notify(`${cloneType} е клонирана успешно!`, { type: "success" });
      })
      .catch(error => {
        notify(`${cloneType} не е клонирана!`, { type: "error" });
        refresh();
        close();
      });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
    >
      <DialogTitle>{`Клонирай версия с № ${record.id}, име:  ${record.name}`}</DialogTitle>

      <SimpleForm
        onSubmit={onSubmit}
        toolbar={<CustomToolbar close={close} />}
      >
        <label>
          Нова страница
          <Switch
            onChange={e => setIsNewPage(e.target.checked)}
            checked={isNewPage}
          />
        </label>

        <TextInput
          fullWidth
          source={isNewPage ? "pageVersionName" : "name"}
          label="Име на нова версия"
          onChange={e => setVersionName(e.target.value)}
        />
        <Accordion open={isNewPage}>
          <label>
            Страница на друг език
            <Switch
              onChange={handleNewLanguage}
              checked={isNewLanguage}
            />
          </label>

          <Accordion open={isNewLanguage}>
            <InputLabel>Език</InputLabel>
            <FormControl>
              <Select
                id="demo-simple-select"
                value={languageId}
                label="Език"
                onChange={handleChange}
                fullWidth={false}
              >
                {languageTypes?.map(language => (
                  <MenuItem
                    key={language.id}
                    value={language.id}
                  >
                    {language.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Accordion>

          <MaterialTextInput
            fullWidth
            required={isNewPage}
            label="Име на новата страница"
            value={pageNameValue}
            onChange={e => setCurrentPageName(e.target.value)}
          ></MaterialTextInput>
          <MaterialTextInput
            fullWidth
            required={isNewPage}
            label="Адрес на новата страница"
            value={routeValue}
            onChange={e => setCurrentRoute(e.target.value)}
          ></MaterialTextInput>
        </Accordion>
      </SimpleForm>
    </Dialog>
  );
};

export default ClonePageVersionsDialog;
